/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOffers} from '../api'

 export const useQueryGetOffers = createReactQueryHook('getOffers', getOffers)
